// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_9m-4";
export var collapsed = "_9m-1";
export var headerBar = "_9m-0";
export var leftHeaderContent = "_9m-3";
export var subjectContainer = "_9m-2";